import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { registerApi } from "@/utils/apis/auth-service";
import { UnconfirmDirection, useRegistrationStore } from "@/utils/stores/useRegistrationStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useRegistration = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent();
    const { updateRegistrationData } = useRegistrationStore();

    const [emailError, setEmailError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const onBackButtonClick = async () => {
        navigate("/login")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
    }

    const handleInputsSubmit = (inputData: { [key: string]: string }, newsletterAccepted: boolean) => {
        const name = inputData.name
        const familyName = inputData.familyName
        const phoneNumber = inputData.phoneNumber
        const email = inputData.email
        const password = inputData.password

        sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: {
                action: "registration",
                email,
                phoneNumber,
            },
        });
        console.log(name, familyName, phoneNumber, email, password)
        callRegister(name, familyName, phoneNumber.replace(/\s+/g, ''), email, password, newsletterAccepted)
    }

    const callRegister = (name: string, familyName: string, phoneNumber: string, email: string, password: string, newsletterAccepted: boolean) => {
        setIsLoading(true)
        registerApi(
            email,
            password,
            name,
            familyName,
            phoneNumber,
            newsletterAccepted,
            (success) => {
                const message = success.message
                sendEvent({
                    event: EventType.REGISTRATION_STARTED,
                    sub_category: "registration",
                    event_metadata: {
                        email,
                    },
                });
                updateRegistrationData({ registrationEmail: email, password, isUnconfirmed: message === "User already exists but is unconfirmed. Please check your email to confirm registration." ? UnconfirmDirection.Registration : UnconfirmDirection.None })
                navigate("/email-registration-code")
                setIsLoading(false)
            },
            (error, showAlert) => {
                sendEvent({
                    event: EventType.REGISTRATION_FAILED,
                    sub_category: "registration",
                    event_metadata: {
                        email,
                        error,
                    },
                });
                if (showAlert) {
                    alert("form error")
                } else {
                    setEmailError(true)
                }
                setIsLoading(false)
            }
        )
    }

    return {
        emailError,
        isLoading,
        handleInputsSubmit,
        onBackButtonClick,
    }
}